// @ngInject
function EconomyApiService($window, DS, DSHttpAdapter, ResourcesService, $q, $document) {

    var endpoint = 'economy';

    return {
        getLocations: ResourcesService.apiFactory.get(endpoint + '/locations'),
        getAccountConfigMessages: ResourcesService.apiFactory.get(endpoint + '/missingaccountsettings'),
        downloadSIEFile: downloadSIEFile
    };

    function downloadSIEFile(fromDate, toDate, organizationNumber) {
        var deferred = $q.defer();
        var url = $window.URL || $window.webkitURL;

        var fromDateString = fromDate.getFullYear() + '-' + _.padStart(fromDate.getMonth() + 1 + '', 2, '0') + '-' + _.padStart(fromDate.getDate(), 2, '0');
        var toDateString = toDate.getFullYear() + '-' + _.padStart(toDate.getMonth() + 1 + '', 2, '0') + '-' + _.padStart(toDate.getDate(), 2, '0');

        var params = {
            startDate: fromDateString,
            endDate: toDateString,
            organizationNumber: organizationNumber
        };

        DSHttpAdapter.GET(DS.defaults.basePath + endpoint + '/siefile', {params: params}).then(function (response) {
            var blob = new Blob([response.data], { type: 'text/plain' });

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, "SIE.SI");
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                var downloadUrl = url.createObjectURL(blob);
                a.href = downloadUrl;
                a.download = "SIE.SI";
                a.click();
                a.remove();
            }

            deferred.resolve(response);
        }, function (error) {
            deferred.reject(error);
        });

        return deferred.promise;
    }

}

angular.module('economy.api', [])
  .factory('EconomyApiService', EconomyApiService);
